/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuditLogTypeFromJSON, AuditLogTypeToJSON, AuditLogUserInfoFromJSON, AuditLogUserInfoToJSON, } from './';
export function AuditLogRepresentationFromJSON(json) {
    return AuditLogRepresentationFromJSONTyped(json, false);
}
export function AuditLogRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        user: AuditLogUserInfoFromJSON(json['user']),
        type: AuditLogTypeFromJSON(json['type']),
        creationTime: new Date(json['creationTime']),
        data: json['data'],
    };
}
export function AuditLogRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        user: AuditLogUserInfoToJSON(value.user),
        type: AuditLogTypeToJSON(value.type),
        creationTime: value.creationTime.toISOString(),
        data: value.data,
    };
}
